(() => {
// ══════════════════════════════════════════════
//  iseeit.jp — オプション価格評価ツール
//  Monte Carlo + Greeks + Yahoo Finance 連携
// ══════════════════════════════════════════════
let $bb77e5b898f7f4d6$var$device = null, $bb77e5b898f7f4d6$var$webgpuOK = false;
let $bb77e5b898f7f4d6$var$pipeline = null;
let $bb77e5b898f7f4d6$var$pathChart = null;
let $bb77e5b898f7f4d6$var$currentType = 'euro';
const $bb77e5b898f7f4d6$var$WG_LIMIT = 65535;
// ── ログ ──
function $bb77e5b898f7f4d6$var$log(msg) {
    const box = document.getElementById('logBox');
    box.innerHTML += msg + '<br>';
    box.scrollTop = box.scrollHeight;
}
function $bb77e5b898f7f4d6$var$clearLog() {
    document.getElementById('logBox').innerHTML = '';
}
function $bb77e5b898f7f4d6$var$setProgress(pct) {
    document.getElementById('progWrap').style.display = pct > 0 && pct < 100 ? 'block' : 'none';
    document.getElementById('progBar').style.width = pct + '%';
}
// ── データソースタブ ──
function $bb77e5b898f7f4d6$var$switchDs(ds) {
    document.querySelectorAll('.ds-tab').forEach((t)=>t.classList.toggle('active', t.dataset.ds === ds));
    document.getElementById('dsManual').classList.toggle('active', ds === 'manual');
    document.getElementById('dsYahoo').classList.toggle('active', ds === 'yahoo');
}
// ── オプションタイプ ──
function $bb77e5b898f7f4d6$var$selectType(type) {
    $bb77e5b898f7f4d6$var$currentType = type;
    document.querySelectorAll('.type-tab').forEach((t)=>t.classList.toggle('active', t.dataset.type === type));
    document.getElementById('barrierBox').style.display = type === 'barrier' ? 'block' : 'none';
    // アジアン/バリアはマルチステップが必要 → STEPSを自動調整の案内
    if (type === 'euro') document.getElementById('predLabel').textContent = "\u30E8\u30FC\u30ED\u30D4\u30A2\u30F3 \u7406\u8AD6\u4FA1\u683C";
    else if (type === 'asian') document.getElementById('predLabel').textContent = "\u30A2\u30B8\u30A2\u30F3 \u7406\u8AD6\u4FA1\u683C";
    else document.getElementById('predLabel').textContent = "\u30D0\u30EA\u30A2 \u7406\u8AD6\u4FA1\u683C";
    // 経路依存タイプで STEPS=1 のままなら日次(252)に引き上げる
    if (type !== 'euro') {
        const stepsSel = document.getElementById('pSteps');
        if (parseInt(stepsSel.value) < 2) stepsSel.value = '252';
    }
}
// ── パラメータ取得 ──
function $bb77e5b898f7f4d6$var$getParams() {
    const barrierType = document.getElementById('pBarrierType').value;
    return {
        s0: parseFloat(document.getElementById('pS0').value),
        k: parseFloat(document.getElementById('pK').value),
        sigma: parseFloat(document.getElementById('pSig').value) / 100,
        r: parseFloat(document.getElementById('pR').value) / 100,
        t: parseFloat(document.getElementById('pT').value),
        steps: parseInt(document.getElementById('pSteps').value),
        numPaths: parseInt(document.getElementById('pN').value),
        isCall: document.getElementById('pType').value === 'call',
        barrier: parseFloat(document.getElementById('pBarrier').value),
        isKnockOut: barrierType.includes('out'),
        isUp: barrierType.includes('up'),
        optType: $bb77e5b898f7f4d6$var$currentType
    };
}
// ── 入力バリデーション ──
// 数値入力(S0,K,バリア)は空欄・負値・NaN・極端な値を弾く。
// ログにエラーを出し、問題があれば false を返す。
function $bb77e5b898f7f4d6$var$validateParams(p) {
    const errors = [];
    // S0: 正の有限数
    if (!isFinite(p.s0) || p.s0 <= 0) errors.push("S\u2080\uFF08\u73FE\u5728\u682A\u4FA1\uFF09\u306F\u6B63\u306E\u6570\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044");
    // K: 正の有限数
    if (!isFinite(p.k) || p.k <= 0) errors.push("K\uFF08\u6A29\u5229\u884C\u4F7F\u4FA1\u683C\uFF09\u306F\u6B63\u306E\u6570\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044");
    // 極端な乖離（計算が無意味になる）
    if (isFinite(p.s0) && isFinite(p.k) && p.s0 > 0 && p.k > 0) {
        const ratio = p.k / p.s0;
        if (ratio > 100 || ratio < 0.01) errors.push("S\u2080 \u3068 K \u304C\u6975\u7AEF\u306B\u4E56\u96E2\u3057\u3066\u3044\u307E\u3059\uFF08\u6BD4\u7387\u306F 0.01\u301C100 \u306E\u7BC4\u56F2\u3092\u63A8\u5968\uFF09");
    }
    // バリア: バリアタイプ選択時のみ
    if (p.optType === 'barrier') {
        if (!isFinite(p.barrier) || p.barrier <= 0) errors.push("\u30D0\u30EA\u30A2\u6C34\u6E96\u306F\u6B63\u306E\u6570\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044");
        else {
            // Up系: バリアは現在価格より上が自然 / Down系: 下が自然
            if (p.isUp && p.barrier <= p.s0) errors.push("Up\u7CFB\u30D0\u30EA\u30A2\u306F\u73FE\u5728\u682A\u4FA1 S\u2080 \u3088\u308A\u9AD8\u304F\u8A2D\u5B9A\u3059\u308B\u306E\u304C\u4E00\u822C\u7684\u3067\u3059");
            if (!p.isUp && p.barrier >= p.s0) errors.push("Down\u7CFB\u30D0\u30EA\u30A2\u306F\u73FE\u5728\u682A\u4FA1 S\u2080 \u3088\u308A\u4F4E\u304F\u8A2D\u5B9A\u3059\u308B\u306E\u304C\u4E00\u822C\u7684\u3067\u3059");
        }
    }
    // σ・r・T はスライダー/選択式なので通常は範囲内だが念のため
    if (!isFinite(p.sigma) || p.sigma <= 0) errors.push("\u03C3\uFF08\u30DC\u30E9\u30C6\u30A3\u30EA\u30C6\u30A3\uFF09\u304C\u4E0D\u6B63\u3067\u3059");
    if (!isFinite(p.t) || p.t <= 0) errors.push("T\uFF08\u6E80\u671F\uFF09\u304C\u4E0D\u6B63\u3067\u3059");
    // アジアン/バリアはマルチステップが必要
    if ((p.optType === 'asian' || p.optType === 'barrier') && p.steps < 2) errors.push(`${p.optType === 'asian' ? "\u30A2\u30B8\u30A2\u30F3" : "\u30D0\u30EA\u30A2"}\u{30AA}\u{30D7}\u{30B7}\u{30E7}\u{30F3}\u{306F} STEPS \u{3092} 2 \u{4EE5}\u{4E0A}\u{306B}\u{3057}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}\u{FF08}\u{7D4C}\u{8DEF}\u{5168}\u{4F53}\u{304C}\u{5FC5}\u{8981}\u{3067}\u{3059}\u{FF09}`);
    if (errors.length > 0) {
        errors.forEach((e)=>$bb77e5b898f7f4d6$var$log(`<span class="err">[\u{5165}\u{529B}\u{30A8}\u{30E9}\u{30FC}]</span> ${e}`));
        return false;
    }
    return true;
}
// ── WGSL ──
const $bb77e5b898f7f4d6$var$WGSL = `
struct Params {
  s0: f32, k: f32, sigma: f32, r: f32,
  t: f32, isCall: f32, barrier: f32, isKnockOut: f32,
  isUp: f32, _pad0: f32, _pad1: f32, _pad2: f32,
  numPaths: u32, steps: u32, optType: u32, seed: u32,
}
@group(0) @binding(0) var<storage, read_write> payoffs: array<f32>;
@group(0) @binding(1) var<uniform> p: Params;

fn pcg(n: u32) -> u32 {
  var h = n * 747796405u + 2891336453u;
  h = ((h >> ((h >> 28u) + 4u)) ^ h) * 277803737u;
  return (h >> 22u) ^ h;
}
fn rand(seed: u32) -> f32 { return f32(pcg(seed)) / 4294967295.0; }
fn randNormal(seed: u32) -> f32 {
  let u1 = max(rand(seed * 2u), 1e-7);
  let u2 = rand(seed * 2u + 1u);
  return sqrt(-2.0 * log(u1)) * cos(6.2831853 * u2);
}

@compute @workgroup_size(64)
fn main(@builtin(global_invocation_id) gid: vec3u,
        @builtin(num_workgroups) nwg: vec3u) {
  let totalThreads = nwg.x * 64u;
  var pathId = gid.x;
  loop {
    if (pathId >= p.numPaths) { break; }
    let dt = p.t / f32(p.steps);
    let drift = (p.r - 0.5 * p.sigma * p.sigma) * dt;
    let volStep = p.sigma * sqrt(dt);
    var s = p.s0;
    var sumS = 0.0;
    var hit = false;
    for (var step = 0u; step < p.steps; step = step + 1u) {
      let z = randNormal(pathId * p.steps + step + p.seed);
      s = s * exp(drift + volStep * z);
      sumS = sumS + s;
      if (p.isUp > 0.5) { if (s >= p.barrier) { hit = true; } }
      else { if (s <= p.barrier) { hit = true; } }
    }
    var payoff = 0.0;
    let vanilla = select(max(p.k - s, 0.0), max(s - p.k, 0.0), p.isCall > 0.5);
    if (p.optType == 0u) {
      payoff = vanilla;
    } else if (p.optType == 1u) {
      let avgS = sumS / f32(p.steps);
      payoff = select(max(p.k - avgS, 0.0), max(avgS - p.k, 0.0), p.isCall > 0.5);
    } else {
      if (p.isKnockOut > 0.5) { payoff = select(vanilla, 0.0, hit); }
      else { payoff = select(0.0, vanilla, hit); }
    }
    payoffs[pathId] = payoff;
    pathId = pathId + totalThreads;
  }
}`;
// ── 初期化 ──
async function $bb77e5b898f7f4d6$var$init() {
    $bb77e5b898f7f4d6$var$selectType('euro');
    $bb77e5b898f7f4d6$var$log('<span class="info">[INIT]</span> WebGPU \u3092\u78BA\u8A8D\u4E2D...');
    if (!navigator.gpu) {
        $bb77e5b898f7f4d6$var$setupCpuOnly("WebGPU\u975E\u5BFE\u5FDC");
        return;
    }
    try {
        const adapter = await navigator.gpu.requestAdapter();
        $bb77e5b898f7f4d6$var$device = await adapter.requestDevice();
        const module = $bb77e5b898f7f4d6$var$device.createShaderModule({
            code: $bb77e5b898f7f4d6$var$WGSL
        });
        const info = await module.getCompilationInfo();
        for (const m of info.messages)if (m.type === 'error') throw new Error(m.message);
        $bb77e5b898f7f4d6$var$pipeline = $bb77e5b898f7f4d6$var$device.createComputePipeline({
            layout: 'auto',
            compute: {
                module: module,
                entryPoint: 'main'
            }
        });
        $bb77e5b898f7f4d6$var$webgpuOK = true;
        const badge = document.getElementById('backendBadge');
        badge.textContent = "BACKEND: WebGPU \u2713";
        badge.className = 'backend-badge ok';
        document.getElementById('btnPrice').disabled = false;
        document.getElementById('btnGreeks').disabled = false;
        $bb77e5b898f7f4d6$var$log('<span class="ok">[OK]</span> WebGPU \u521D\u671F\u5316\u5B8C\u4E86');
    } catch (e) {
        $bb77e5b898f7f4d6$var$setupCpuOnly("WebGPU\u521D\u671F\u5316\u5931\u6557");
    }
}
function $bb77e5b898f7f4d6$var$setupCpuOnly(reason) {
    $bb77e5b898f7f4d6$var$webgpuOK = false;
    const badge = document.getElementById('backendBadge');
    badge.textContent = 'BACKEND: CPU';
    badge.className = 'backend-badge';
    document.getElementById('btnPrice').disabled = false;
    document.getElementById('btnGreeks').disabled = false;
    $bb77e5b898f7f4d6$var$log('<span class="warn">[WARN]</span> ' + reason + "\u3002CPU \u3067\u8A08\u7B97\u3057\u307E\u3059");
}
// ── uniform ──
function $bb77e5b898f7f4d6$var$makeUniform(params, seed) {
    const ab = new ArrayBuffer(64);
    const fv = new Float32Array(ab), uv = new Uint32Array(ab);
    fv[0] = params.s0;
    fv[1] = params.k;
    fv[2] = params.sigma;
    fv[3] = params.r;
    fv[4] = params.t;
    fv[5] = params.isCall ? 1 : 0;
    fv[6] = params.barrier;
    fv[7] = params.isKnockOut ? 1 : 0;
    fv[8] = params.isUp ? 1 : 0;
    const optTypeNum = params.optType === 'euro' ? 0 : params.optType === 'asian' ? 1 : 2;
    uv[12] = params.numPaths;
    uv[13] = params.steps;
    uv[14] = optTypeNum;
    uv[15] = seed;
    return ab;
}
// ── GPU 価格評価（価格と標準誤差を返す）──
async function $bb77e5b898f7f4d6$var$priceGPU(params, seed = 12345) {
    const NUM = params.numPaths;
    const payoffBuf = $bb77e5b898f7f4d6$var$device.createBuffer({
        size: NUM * 4,
        usage: GPUBufferUsage.STORAGE | GPUBufferUsage.COPY_SRC
    });
    const uniBuf = $bb77e5b898f7f4d6$var$device.createBuffer({
        size: 64,
        usage: GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST
    });
    const readBuf = $bb77e5b898f7f4d6$var$device.createBuffer({
        size: NUM * 4,
        usage: GPUBufferUsage.MAP_READ | GPUBufferUsage.COPY_DST
    });
    $bb77e5b898f7f4d6$var$device.queue.writeBuffer(uniBuf, 0, $bb77e5b898f7f4d6$var$makeUniform(params, seed));
    const bind = $bb77e5b898f7f4d6$var$device.createBindGroup({
        layout: $bb77e5b898f7f4d6$var$pipeline.getBindGroupLayout(0),
        entries: [
            {
                binding: 0,
                resource: {
                    buffer: payoffBuf
                }
            },
            {
                binding: 1,
                resource: {
                    buffer: uniBuf
                }
            }
        ]
    });
    const enc = $bb77e5b898f7f4d6$var$device.createCommandEncoder();
    const pass = enc.beginComputePass();
    pass.setPipeline($bb77e5b898f7f4d6$var$pipeline);
    pass.setBindGroup(0, bind);
    pass.dispatchWorkgroups(Math.min(Math.ceil(NUM / 64), $bb77e5b898f7f4d6$var$WG_LIMIT));
    pass.end();
    enc.copyBufferToBuffer(payoffBuf, 0, readBuf, 0, NUM * 4);
    $bb77e5b898f7f4d6$var$device.queue.submit([
        enc.finish()
    ]);
    await readBuf.mapAsync(GPUMapMode.READ);
    const payoffs = new Float32Array(readBuf.getMappedRange());
    let sum = 0, sumSq = 0;
    for(let i = 0; i < NUM; i++){
        sum += payoffs[i];
        sumSq += payoffs[i] * payoffs[i];
    }
    readBuf.unmap();
    payoffBuf.destroy();
    uniBuf.destroy();
    readBuf.destroy();
    const mean = sum / NUM, discount = Math.exp(-params.r * params.t);
    const price = mean * discount;
    const variance = sumSq / NUM - mean * mean;
    const se = discount * Math.sqrt(Math.max(variance, 0) / NUM);
    return {
        price: price,
        se: se
    };
}
// ── CPU 価格評価 ──
function $bb77e5b898f7f4d6$var$priceCPU(params, seed = 12345) {
    const NUM = params.numPaths;
    let sum = 0, sumSq = 0;
    let s_ = seed >>> 0;
    const rng = ()=>{
        s_ |= 0;
        s_ = s_ + 0x6D2B79F5 | 0;
        let t = Math.imul(s_ ^ s_ >>> 15, 1 | s_);
        t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t;
        return ((t ^ t >>> 14) >>> 0) / 4294967296;
    };
    const dt = params.t / params.steps;
    const drift = (params.r - 0.5 * params.sigma * params.sigma) * dt;
    const volStep = params.sigma * Math.sqrt(dt);
    const optTypeNum = params.optType === 'euro' ? 0 : params.optType === 'asian' ? 1 : 2;
    for(let i = 0; i < NUM; i++){
        let s = params.s0, sumS = 0, hit = false;
        for(let step = 0; step < params.steps; step++){
            const u1 = Math.max(rng(), 1e-7), u2 = rng();
            const z = Math.sqrt(-2 * Math.log(u1)) * Math.cos(6.2831853 * u2);
            s = s * Math.exp(drift + volStep * z);
            sumS += s;
            if (params.isUp ? s >= params.barrier : s <= params.barrier) hit = true;
        }
        let payoff = 0;
        const vanilla = params.isCall ? Math.max(s - params.k, 0) : Math.max(params.k - s, 0);
        if (optTypeNum === 0) payoff = vanilla;
        else if (optTypeNum === 1) {
            const a = sumS / params.steps;
            payoff = params.isCall ? Math.max(a - params.k, 0) : Math.max(params.k - a, 0);
        } else if (params.isKnockOut) payoff = hit ? 0 : vanilla;
        else payoff = hit ? vanilla : 0;
        sum += payoff;
        sumSq += payoff * payoff;
    }
    const mean = sum / NUM, discount = Math.exp(-params.r * params.t);
    const price = mean * discount;
    const variance = sumSq / NUM - mean * mean;
    const se = discount * Math.sqrt(Math.max(variance, 0) / NUM);
    return {
        price: price,
        se: se
    };
}
async function $bb77e5b898f7f4d6$var$priceAny(params, seed) {
    return $bb77e5b898f7f4d6$var$webgpuOK ? await $bb77e5b898f7f4d6$var$priceGPU(params, seed) : $bb77e5b898f7f4d6$var$priceCPU(params, seed);
}
// ── Black-Scholes（参考値）──
function $bb77e5b898f7f4d6$var$normCDF(x) {
    const a1 = 0.254829592, a2 = -0.284496736, a3 = 1.421413741, a4 = -1.453152027, a5 = 1.061405429, pc = 0.3275911;
    const sign = x < 0 ? -1 : 1;
    x = Math.abs(x) / Math.sqrt(2);
    const t = 1 / (1 + pc * x);
    const y = 1 - ((((a5 * t + a4) * t + a3) * t + a2) * t + a1) * t * Math.exp(-x * x);
    return 0.5 * (1 + sign * y);
}
function $bb77e5b898f7f4d6$var$blackScholes(S0, K, sigma, r, T, isCall) {
    const d1 = (Math.log(S0 / K) + (r + 0.5 * sigma * sigma) * T) / (sigma * Math.sqrt(T));
    const d2 = d1 - sigma * Math.sqrt(T);
    if (isCall) return S0 * $bb77e5b898f7f4d6$var$normCDF(d1) - K * Math.exp(-r * T) * $bb77e5b898f7f4d6$var$normCDF(d2);
    return K * Math.exp(-r * T) * $bb77e5b898f7f4d6$var$normCDF(-d2) - S0 * $bb77e5b898f7f4d6$var$normCDF(-d1);
}
// ── 価格評価実行 ──
async function $bb77e5b898f7f4d6$var$runPricing() {
    document.getElementById('btnPrice').disabled = true;
    document.getElementById('btnGreeks').disabled = true;
    // 価格を再計算したらグリークスは古くなるので一旦隠す
    document.getElementById('greeksGrid').classList.remove('show');
    $bb77e5b898f7f4d6$var$clearLog();
    const params = $bb77e5b898f7f4d6$var$getParams();
    if (!$bb77e5b898f7f4d6$var$validateParams(params)) {
        document.getElementById('btnPrice').disabled = false;
        document.getElementById('btnGreeks').disabled = false;
        return;
    }
    $bb77e5b898f7f4d6$var$log(`<span class="info">[PRICE]</span> ${params.optType} ${params.isCall ? 'call' : 'put'} / ${params.numPaths.toLocaleString()}\u{30D1}\u{30B9} \xd7 ${params.steps}step`);
    $bb77e5b898f7f4d6$var$setProgress(30);
    await new Promise((r)=>setTimeout(r, 20));
    const t0 = performance.now();
    let res;
    try {
        res = await $bb77e5b898f7f4d6$var$priceAny(params);
    } catch (e) {
        $bb77e5b898f7f4d6$var$log('<span class="warn">[WARN]</span> GPU\u5931\u6557\u3001CPU\u3078');
        res = $bb77e5b898f7f4d6$var$priceCPU(params);
    }
    const t1 = performance.now();
    $bb77e5b898f7f4d6$var$setProgress(100);
    document.getElementById('predBox').style.display = 'block';
    document.getElementById('predVal').textContent = res.price.toFixed(4);
    document.getElementById('predSub').textContent = `${params.numPaths.toLocaleString()} paths \xb7 SE \xb1${res.se.toFixed(4)}`;
    const ref = $bb77e5b898f7f4d6$var$blackScholes(params.s0, params.k, params.sigma, params.r, params.t, params.isCall);
    document.getElementById('statsGrid').classList.add('show');
    document.getElementById('stRef').textContent = ref.toFixed(4);
    document.getElementById('stSE').textContent = "\xb1" + res.se.toFixed(4);
    document.getElementById('stTime').textContent = (t1 - t0).toFixed(0) + 'ms';
    $bb77e5b898f7f4d6$var$log(`<span class="ok">[OK]</span> \u{4FA1}\u{683C} = ${res.price.toFixed(4)} (${(t1 - t0).toFixed(0)}ms)`);
    $bb77e5b898f7f4d6$var$drawSamplePaths(params);
    document.getElementById('btnPrice').disabled = false;
    document.getElementById('btnGreeks').disabled = false;
    setTimeout(()=>$bb77e5b898f7f4d6$var$setProgress(0), 400);
}
// ── グリークス（有限差分）──
async function $bb77e5b898f7f4d6$var$runGreeks() {
    document.getElementById('btnPrice').disabled = true;
    document.getElementById('btnGreeks').disabled = true;
    $bb77e5b898f7f4d6$var$clearLog();
    const base = $bb77e5b898f7f4d6$var$getParams();
    if (!$bb77e5b898f7f4d6$var$validateParams(base)) {
        document.getElementById('btnPrice').disabled = false;
        document.getElementById('btnGreeks').disabled = false;
        return;
    }
    $bb77e5b898f7f4d6$var$log('<span class="info">[GREEKS]</span> \u6709\u9650\u5DEE\u5206\u30675\u6307\u6A19\u3092\u8A08\u7B97\u4E2D...');
    // 共通シードで分散低減（同じ乱数列で差分を取る）
    const SEED = 777;
    const bump = {
        s: base.s0 * 0.01,
        vol: 0.01,
        t: 1 / 365,
        r: 0.0001
    };
    let step = 0;
    const total = 7;
    const prog = ()=>{
        step++;
        $bb77e5b898f7f4d6$var$setProgress(step / total * 100);
    };
    const price = async (mod)=>{
        const pr = {
            ...base,
            ...mod
        };
        const res = await $bb77e5b898f7f4d6$var$priceAny(pr, SEED);
        prog();
        await new Promise((r)=>setTimeout(r, 5));
        return res.price;
    };
    // 基準
    const p0 = await price({});
    // Delta, Gamma: S を ±bump（中心差分）
    const pSup = await price({
        s0: base.s0 + bump.s
    });
    const pSdn = await price({
        s0: base.s0 - bump.s
    });
    const delta = (pSup - pSdn) / (2 * bump.s);
    const gamma = (pSup - 2 * p0 + pSdn) / (bump.s * bump.s);
    // Vega: σ を +1%ポイント → 価格変化がそのまま per-1%-Vega
    const pVup = await price({
        sigma: base.sigma + bump.vol
    });
    const vega = pVup - p0;
    // Theta: T を -1日 → 価格変化がそのまま per-day-Theta
    const pTdn = await price({
        t: Math.max(base.t - bump.t, 1e-4)
    });
    const theta = pTdn - p0;
    // Rho: r を +1bp → per-1% に換算（×100）
    const pRup = await price({
        r: base.r + bump.r
    });
    const rho = (pRup - p0) * 100;
    document.getElementById('greeksGrid').classList.add('show');
    document.getElementById('gDelta').textContent = delta.toFixed(4);
    document.getElementById('gGamma').textContent = gamma.toFixed(5);
    document.getElementById('gVega').textContent = vega.toFixed(4);
    document.getElementById('gTheta').textContent = theta.toFixed(4);
    document.getElementById('gRho').textContent = rho.toFixed(4);
    $bb77e5b898f7f4d6$var$log(`<span class="ok">[OK]</span> \u{394}=${delta.toFixed(4)} \u{393}=${gamma.toFixed(5)} \u{3BD}=${vega.toFixed(4)} \u{398}=${theta.toFixed(4)} \u{3C1}=${rho.toFixed(4)}`);
    $bb77e5b898f7f4d6$var$setProgress(100);
    document.getElementById('btnPrice').disabled = false;
    document.getElementById('btnGreeks').disabled = false;
    setTimeout(()=>$bb77e5b898f7f4d6$var$setProgress(0), 400);
}
// ── サンプルパス描画 ──
function $bb77e5b898f7f4d6$var$drawSamplePaths(params) {
    const numSample = 80;
    const steps = Math.min(params.steps < 2 ? 50 : params.steps, 252);
    const dt = params.t / steps;
    const drift = (params.r - 0.5 * params.sigma * params.sigma) * dt;
    const volStep = params.sigma * Math.sqrt(dt);
    let s_ = 98765;
    const rng = ()=>{
        s_ |= 0;
        s_ = s_ + 0x6D2B79F5 | 0;
        let t = Math.imul(s_ ^ s_ >>> 15, 1 | s_);
        t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t;
        return ((t ^ t >>> 14) >>> 0) / 4294967296;
    };
    const paths = [];
    for(let p = 0; p < numSample; p++){
        const path = [
            params.s0
        ];
        let s = params.s0;
        for(let step = 0; step < steps; step++){
            const u1 = Math.max(rng(), 1e-7), u2 = rng();
            const z = Math.sqrt(-2 * Math.log(u1)) * Math.cos(6.2831853 * u2);
            s = s * Math.exp(drift + volStep * z);
            path.push(s);
        }
        paths.push(path);
    }
    const labels = Array.from({
        length: steps + 1
    }, (_, i)=>(i / steps * params.t).toFixed(2));
    const ctx = document.getElementById('pathChart').getContext('2d');
    if ($bb77e5b898f7f4d6$var$pathChart) $bb77e5b898f7f4d6$var$pathChart.destroy();
    const datasets = paths.map((path, i)=>({
            label: '',
            data: path,
            borderColor: `hsla(${190 + i % 40}, 80%, 60%, 0.22)`,
            borderWidth: 0.7,
            pointRadius: 0,
            tension: 0.1
        }));
    datasets.push({
        label: "K (\u884C\u4F7F\u4FA1\u683C)",
        data: labels.map(()=>params.k),
        borderColor: 'rgba(255,107,53,0.85)',
        borderWidth: 1.5,
        borderDash: [
            5,
            3
        ],
        pointRadius: 0
    });
    if (params.optType === 'barrier') datasets.push({
        label: 'Barrier',
        data: labels.map(()=>params.barrier),
        borderColor: 'rgba(255,68,68,0.9)',
        borderWidth: 1.5,
        borderDash: [
            3,
            2
        ],
        pointRadius: 0
    });
    document.getElementById('chartOuter').style.display = 'block';
    $bb77e5b898f7f4d6$var$pathChart = new Chart(ctx, {
        type: 'line',
        data: {
            labels: labels,
            datasets: datasets
        },
        options: {
            responsive: true,
            maintainAspectRatio: false,
            animation: {
                duration: 250
            },
            plugins: {
                legend: {
                    display: true,
                    labels: {
                        color: '#7a8a9e',
                        font: {
                            family: 'DM Mono',
                            size: 10
                        },
                        boxWidth: 12,
                        filter: (it)=>it.text !== ''
                    }
                }
            },
            scales: {
                x: {
                    title: {
                        display: true,
                        text: "t (\u5E74)",
                        color: '#6a7a92',
                        font: {
                            family: 'DM Mono',
                            size: 10
                        }
                    },
                    ticks: {
                        color: '#7a8a9e',
                        maxTicksLimit: 8,
                        font: {
                            family: 'DM Mono',
                            size: 10
                        }
                    },
                    grid: {
                        color: 'rgba(30,37,53,.6)'
                    }
                },
                y: {
                    title: {
                        display: true,
                        text: "\u682A\u4FA1",
                        color: '#6a7a92',
                        font: {
                            family: 'DM Mono',
                            size: 10
                        }
                    },
                    ticks: {
                        color: '#7a8a9e',
                        font: {
                            family: 'DM Mono',
                            size: 10
                        }
                    },
                    grid: {
                        color: 'rgba(30,37,53,.6)'
                    }
                }
            }
        }
    });
}
// ── Yahoo Finance からボラティリティ推定 ──
function $bb77e5b898f7f4d6$var$buildProxies(symbol, range) {
    const selfProxy = 'https://www.iseeit.jp/tools/yf-proxy.php' + `?symbol=${encodeURIComponent(symbol)}&range=${encodeURIComponent(range)}`;
    const yfUrl = `https://query1.finance.yahoo.com/v8/finance/chart/${encodeURIComponent(symbol)}` + `?interval=1d&range=${range}&events=history`;
    const enc = encodeURIComponent(yfUrl);
    return [
        {
            name: 'iseeit.jp proxy',
            url: selfProxy,
            parse: (r)=>r.json()
        },
        {
            name: 'corsproxy.io',
            url: `https://corsproxy.io/?${enc}`,
            parse: (r)=>r.json()
        },
        {
            name: 'allorigins.win',
            url: `https://allorigins.win/get?disableCache=true&url=${enc}`,
            parse: async (r)=>{
                const d = await r.json();
                return JSON.parse(d.contents);
            }
        }
    ];
}
function $bb77e5b898f7f4d6$var$setPBadge(i, s) {
    const b = document.getElementById('pb' + i);
    if (b) b.className = 'pbadge ' + s;
}
async function $bb77e5b898f7f4d6$var$fetchYahooVol() {
    const sym = document.getElementById('yfSymbol').value.trim();
    const range = document.getElementById('yfRange').value;
    $bb77e5b898f7f4d6$var$clearLog();
    [
        0,
        1,
        2
    ].forEach((i)=>$bb77e5b898f7f4d6$var$setPBadge(i, ''));
    const btn = document.getElementById('fetchBtn');
    btn.disabled = true;
    btn.textContent = "\u53D6\u5F97\u4E2D...";
    $bb77e5b898f7f4d6$var$log(`<span class="info">[FETCH]</span> ${sym} (${range})`);
    const proxies = $bb77e5b898f7f4d6$var$buildProxies(sym, range);
    let closes = null;
    for(let i = 0; i < proxies.length; i++){
        $bb77e5b898f7f4d6$var$setPBadge(i, 'try');
        $bb77e5b898f7f4d6$var$log(`<span class="info">[TRY]</span> ${proxies[i].name}`);
        try {
            const res = await Promise.race([
                fetch(proxies[i].url),
                new Promise((_, rej)=>setTimeout(()=>rej(new Error('timeout')), 8000))
            ]);
            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            const json = await proxies[i].parse(res);
            const result = json?.chart?.result?.[0];
            if (!result) throw new Error("\u30C7\u30FC\u30BF\u306A\u3057");
            const q = result.indicators?.quote?.[0];
            if (!q || !q.close) throw new Error("quotes \u306A\u3057");
            closes = q.close.filter((v)=>v != null);
            if (closes.length < 20) throw new Error("\u30C7\u30FC\u30BF\u4E0D\u8DB3");
            $bb77e5b898f7f4d6$var$setPBadge(i, 'ok');
            for(let j = i + 1; j < 3; j++)document.getElementById('pb' + j).className = 'pbadge';
            $bb77e5b898f7f4d6$var$log(`<span class="ok">[OK]</span> ${closes.length} \u{4EF6}\u{306E}\u{7D42}\u{5024}\u{3092}\u{53D6}\u{5F97}`);
            break;
        } catch (e) {
            $bb77e5b898f7f4d6$var$log(`<span class="warn">[FAIL]</span> ${proxies[i].name}: ${e.message}`);
            $bb77e5b898f7f4d6$var$setPBadge(i, 'fail');
        }
    }
    btn.disabled = false;
    btn.textContent = "\u25B6 \u30C7\u30FC\u30BF\u53D6\u5F97\u3057\u3066\u03C3\u3092\u63A8\u5B9A";
    if (!closes) {
        $bb77e5b898f7f4d6$var$log('<span class="err">[ERROR]</span> \u53D6\u5F97\u5931\u6557\u3002\u624B\u52D5\u5165\u529B\u30BF\u30D6\u3067 \u03C3 \u3092\u8A2D\u5B9A\u3057\u3066\u304F\u3060\u3055\u3044');
        return;
    }
    // 日次対数収益率 → 年率ボラティリティ
    const logRets = [];
    for(let i = 1; i < closes.length; i++)logRets.push(Math.log(closes[i] / closes[i - 1]));
    const mean = logRets.reduce((a, b)=>a + b, 0) / logRets.length;
    const variance = logRets.reduce((a, b)=>a + (b - mean) ** 2, 0) / (logRets.length - 1);
    const dailyVol = Math.sqrt(variance);
    const annualVol = dailyVol * Math.sqrt(252);
    const volPct = Math.round(annualVol * 100);
    // σスライダーに反映
    const sigSlider = document.getElementById('pSig');
    const clamped = Math.max(5, Math.min(80, volPct));
    sigSlider.value = clamped;
    document.getElementById('sigVal').textContent = clamped + '%';
    // 最新終値を S0 に反映（数値入力なので価格レンジ制限なし）
    const lastClose = closes[closes.length - 1];
    const s0Input = document.getElementById('pS0');
    s0Input.value = lastClose.toFixed(2);
    const fi = document.getElementById('fileInfo');
    fi.className = 'file-info show';
    fi.innerHTML = `\u{63A8}\u{5B9A}\u{30DC}\u{30E9}\u{30C6}\u{30A3}\u{30EA}\u{30C6}\u{30A3}: <strong>${annualVol * 100 >= 100 ? '>100' : (annualVol * 100).toFixed(1)}%</strong>\u{FF08}\u{5E74}\u{7387}\u{FF09}` + ` / \u{6700}\u{65B0}\u{7D42}\u{5024}: ${lastClose.toFixed(2)}` + (volPct !== clamped ? `<br>\u{203B} \u{3C3}\u{306F} ${clamped}% \u{306B}\u{4E38}\u{3081}\u{307E}\u{3057}\u{305F}\u{FF08}\u{7BC4}\u{56F2}5\u{301C}80%\u{FF09}` : '');
    $bb77e5b898f7f4d6$var$log(`<span class="ok">[VOL]</span> \u{5E74}\u{7387}\u{30DC}\u{30E9}\u{30C6}\u{30A3}\u{30EA}\u{30C6}\u{30A3} = ${(annualVol * 100).toFixed(1)}% \u{2192} \u{3C3}=${clamped}% \u{306B}\u{8A2D}\u{5B9A}`);
    $bb77e5b898f7f4d6$var$log('<span class="info">[INFO]</span> \u30AA\u30D7\u30B7\u30E7\u30F3\u30BF\u30A4\u30D7\u3068\u30D1\u30E9\u30E1\u30FC\u30BF\u3092\u8A2D\u5B9A\u3057\u3001\u4FA1\u683C\u3092\u8A08\u7B97\u3057\u3066\u304F\u3060\u3055\u3044');
}
document.getElementById("dsTabManual").addEventListener("click", ()=>{
    $bb77e5b898f7f4d6$var$switchDs('manual');
});
document.getElementById("dsTabYahoo").addEventListener("click", ()=>{
    $bb77e5b898f7f4d6$var$switchDs('yahoo');
});
document.getElementById("fetchBtn").addEventListener("click", $bb77e5b898f7f4d6$var$fetchYahooVol);
document.getElementById("typeTabEuro").addEventListener("click", ()=>{
    $bb77e5b898f7f4d6$var$selectType('euro');
});
document.getElementById("typeTabAsian").addEventListener("click", ()=>{
    $bb77e5b898f7f4d6$var$selectType('asian');
});
document.getElementById("typeTabBarrier").addEventListener("click", ()=>{
    $bb77e5b898f7f4d6$var$selectType('barrier');
});
document.getElementById("btnPrice").addEventListener("click", $bb77e5b898f7f4d6$var$runPricing);
document.getElementById("btnGreeks").addEventListener("click", $bb77e5b898f7f4d6$var$runGreeks);
window.addEventListener('load', ()=>{
    $bb77e5b898f7f4d6$var$init();
});

})();
//# sourceMappingURL=option-pricer.js.map
